import { ReactNode, useEffect, useRef } from "react";

export function FocusWrapper(props: {
  isFocused: boolean;
  focusedBlockType?: string;
  children?: ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (props.isFocused && ref.current) {
      ref.current.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }, [props.isFocused]);

  return (
    <div className="relative scroll-mx-0 scroll-my-10" ref={ref}>
      {props.isFocused && (
        <div
          data-content={props.focusedBlockType}
          className="pointer-events-none absolute animate-highlight rounded-sm border-2 border-solid border-[hsl(234,_41%,_41%)] before:absolute before:rounded-br-sm before:bg-[hsl(234,_41%,_41%)] before:p-[1px_5px_3px_5px] before:text-xs before:text-[hsl(40,_100%,_99%)] before:content-[attr(data-content)]"
        />
      )}
      {props.children}
    </div>
  );
}
